'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# GradCapSVG
An SVG graduation cap icon
 */
var GradCapSVG = function GradCapSVG(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === undefined ? undefined : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? undefined : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? undefined : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      x: '0px',
      y: '0px',
      viewBox: '0 0 513 364',
      'aria-label': 'Graduation Cap',
      role: 'img',
      height: height || undefined,
      width: width || undefined
    },
    _react2.default.createElement(
      'title',
      null,
      'Graduation Cap'
    ),
    _react2.default.createElement(
      'desc',
      null,
      'An SVG graduation cap icon'
    ),
    _react2.default.createElement(
      'g',
      {
        stroke: 'none',
        strokeWidth: '1',
        fillRule: 'evenodd'
      },
      _react2.default.createElement(
        'g',
        {
          fill: color,
          fillRule: 'nonzero'
        },
        _react2.default.createElement('path', {
          d: 'M512,125.2 C508.9,127.4 506.1,130.1 502.8,131.7 C426.6,168.1 350.4,204.4 274.2,240.8 C262.5,246.4 250.7,246.8 239.1,241.3 C208.9,227.1 178.8,212.6 148.7,198.1 C146.3,197 144.4,194.8 142.3,193.1 C144.4,191.2 146.2,188.8 148.6,187.5 C178.5,171.8 208.4,156.3 238.5,140.9 C241,139.6 244.5,139.3 247.3,139.8 C257.3,141.3 266.9,140.9 275.8,135.6 C287.3,128.7 287.4,116.9 275.8,110.4 C262.2,102.8 248.3,103.2 235,111.2 C229.1,114.8 226.4,120.4 228.7,127.9 C219.6,132.7 210.5,137.4 201.4,142.2 C178.2,154.2 155,166.2 131.9,178.4 C128.9,180 126.5,182.7 122.8,185.7 C111.8,180.5 99.3,174.8 86.9,168.9 C61.2,156.7 35.6,144.5 9.9,132.2 C8.8,131.7 7.8,131.2 6.8,130.6 C3.5,128.8 -0.7,126.9 0.4,122.8 C1.2,119.8 4.2,116.5 7.1,115.1 C48.5,95.1 90.1,75.3 131.7,55.5 C166.2,39.1 200.7,22.5 235.3,6.3 C240.9,3.7 247.2,2.3 253.1,0.3 C255.1,0.3 257.1,0.3 259.1,0.3 C264.3,1.9 269.8,2.9 274.6,5.2 C350.8,41.4 427,77.7 503.2,114.1 C506.4,115.6 509.1,118.2 512.1,120.2 C512,121.8 512,123.5 512,125.2 Z'
        }),
        _react2.default.createElement('path', {
          d: 'M415.6,188 C415.6,203.3 415.6,217.8 415.6,232.3 C415.6,236.1 415.3,240 415.6,243.8 C416.7,257 411.6,267.8 403.3,277.5 C385.3,298.5 362.3,312.3 337,322.4 C279.8,345.3 222.8,344.1 166.3,319.5 C162.9,318 161.4,316.4 160.9,312.4 C157.3,281.5 153.2,250.7 149.4,219.8 C149.2,218 149.2,216.2 149,213.5 C151.7,214.7 153.9,215.6 156,216.6 C183.1,229.6 210.2,242.6 237.3,255.8 C250,262 262.4,261.9 275.1,255.7 C320,233.9 364.9,212.3 409.8,190.7 C411.3,189.8 413,189.1 415.6,188 Z'
        }),
        _react2.default.createElement('path', {
          d: 'M131.9,207.9 C134.6,228 137.2,248.1 139.9,268.2 C143.1,292.6 146.2,317 149.6,341.4 C151,351.5 145.7,360.8 136.6,363.1 C126.6,365.6 117,360.5 113.7,350.5 C113,348.5 113,346.2 113.2,344.1 C116.7,317.4 120.3,290.7 123.9,264 C126.4,245.2 128.7,226.4 131.1,207.7 C131.3,207.7 131.6,207.8 131.9,207.9 Z'
        }),
        _react2.default.createElement('path', {
          d: 'M94.9,187.3 C100.8,190.1 106,193.1 111.6,195.1 C116.3,196.8 116.2,199.8 115.7,203.7 C114.4,213.7 113.2,223.8 111.9,233.9 C110.1,247.8 108.4,261.8 106.5,276.9 C99.7,268.7 94.7,260.8 94.5,251 C94.3,230.7 94.4,210.4 94.4,190.1 C94.5,189.3 94.7,188.7 94.9,187.3 Z'
        })
      )
    )
  );
};

GradCapSVG.propTypes = {
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string,
  /** a color for the icon */
  color: _propTypes2.default.string
};

GradCapSVG.displayName = 'GradCapSVG';

exports.default = GradCapSVG;
GradCapSVG.__docgenInfo = {
  'description': '# GradCapSVG\r\nAn SVG graduation cap icon',
  'methods': [],
  'displayName': 'GradCapSVG',
  'props': {
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    },
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    }
  }
};